import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { CB } from '../../../../constants/paymentMethods';

import CardsPicto from './CardsPicto';
import CheckoutFlowForm from '../../payment-step/payment-methods/checkout-flow/CheckoutFlowForm';

import './CreditCardStyle.scss';

const CreditCard = ({ selectedMethod, handleMethodChange, userInfo, partnerId, i18n }) => {
    const isSelected = selectedMethod === CB;

    return (
        <div id="credit-card-container" onClick={() => handleMethodChange(CB)}>
            <div className="cb-header">
                <div>
                    <input
                        type="radio"
                        id="cb"
                        name="cb"
                        value={CB}
                        checked={isSelected}
                        readOnly
                    />

                    <label htmlFor="cb">{i18n.PAYMENT_CHOICE.CB}</label>
                </div>
                <CardsPicto />
            </div>

            {isSelected && (
                <div className="cb-form" onClick={e => e.stopPropagation()}>
                    <CheckoutFlowForm userInfo={userInfo} partnerId={partnerId} />
                </div>
            )}
        </div>
    );
};

CreditCard.propTypes = {
    selectedMethod: PropTypes.string,
    handleMethodChange: PropTypes.func,
    userInfo: PropTypes.object,
    partnerId: PropTypes.number
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EBON
    };
};

export default connect(mapStateToProps)(CreditCard);



// WEBPACK FOOTER //
// ./src/components/funnel/payment-selection-step/payment-choice/CreditCard.js